module.exports = __webpack_public_path__ + "img/mono-mag-ore.5c59db01.png";